import { Injectable } from "@angular/core";
import { BrandOverlayDataHeight, BrandOverlayDataWidth } from "@common/domain";
import { Store, select } from "@ngrx/store";
import {
  RoomBrandOverlayDeferredErrorVO,
  RoomBrandOverlayDeleteEventVO,
  RoomBrandOverlaySetEventVO,
  RoomBrandOverlayCreate1VO,
  RoomBrandOverlayCreate2VO,
  RoomBrandOverlayDeleteVO,
  RoomBrandOverlayUnUseVO,
  RoomBrandOverlayUseVO
} from "@youm-front/room/domain";
import { fileImageDimension } from "@youm-front/utils/image";
import { invalidImageFileMessage } from "./invalid-image-file-message";
import { RoomBrandOverlayActions } from "../actions";
import { RoomBrandOverlayEvents } from "../events";
import { RoomBrandOverlaySelectors } from "../selectors";

@Injectable()
export class RoomBrandOverlayFacade {
  brandOverlay$ = this.store.pipe(
    select(RoomBrandOverlaySelectors.brandOverlay)
  );
  isLoading$ = this.store.pipe(select(RoomBrandOverlaySelectors.isLoading));

  constructor(private readonly store: Store) {}

  roomBrandOverlayDeferredErrorEvent(
    roomBrandOverlayDeferredErrorVO: RoomBrandOverlayDeferredErrorVO
  ) {
    this.store.dispatch(
      RoomBrandOverlayEvents.roomBrandOverlayDeferredErrorEvent({
        roomBrandOverlayDeferredErrorVO
      })
    );
  }

  roomBrandOverlayDeleteEvent(
    roomBrandOverlayDeleteEventVO: RoomBrandOverlayDeleteEventVO
  ) {
    this.store.dispatch(
      RoomBrandOverlayEvents.roomBrandOverlayDeleteEvent({
        roomBrandOverlayDeleteEventVO
      })
    );
  }

  roomBrandOverlaySetEvent(
    roomBrandOverlaySetEventVO: RoomBrandOverlaySetEventVO
  ) {
    this.store.dispatch(
      RoomBrandOverlayEvents.roomBrandOverlaySetEvent({
        roomBrandOverlaySetEventVO
      })
    );
  }

  async roomBrandOverlayCreate(
    roomBrandOverlayCreate1VO: RoomBrandOverlayCreate1VO
  ) {
    let dimension: { width: number; height: number };
    try {
      dimension = await fileImageDimension(
        roomBrandOverlayCreate1VO.value.data
      );
    } catch {
      this.store.dispatch(
        RoomBrandOverlayActions.roomBrandOverlayCreateFailure({
          error: invalidImageFileMessage()
        })
      );
      return;
    }
    const { width, height } = dimension;

    const roomBrandOverlayCreate2VO = new RoomBrandOverlayCreate2VO({
      brandId: roomBrandOverlayCreate1VO.value.brandId,
      data: roomBrandOverlayCreate1VO.value.data,
      roomId: roomBrandOverlayCreate1VO.value.roomId,
      width: width as BrandOverlayDataWidth,
      height: height as BrandOverlayDataHeight
    });

    this.store.dispatch(
      RoomBrandOverlayActions.roomBrandOverlayCreate({
        roomBrandOverlayCreateVO: roomBrandOverlayCreate2VO
      })
    );
  }

  roomBrandOverlayDelete(roomBrandOverlayDeleteVO: RoomBrandOverlayDeleteVO) {
    this.store.dispatch(
      RoomBrandOverlayActions.roomBrandOverlayDelete({
        roomBrandOverlayDeleteVO
      })
    );
  }

  roomBrandOverlayUnUse(roomBrandOverlayUnUseVO: RoomBrandOverlayUnUseVO) {
    this.store.dispatch(
      RoomBrandOverlayActions.roomBrandOverlayUnUse({
        roomBrandOverlayUnUseVO
      })
    );
  }

  roomBrandOverlayUse(roomBrandOverlayUseVO: RoomBrandOverlayUseVO) {
    this.store.dispatch(
      RoomBrandOverlayActions.roomBrandOverlayUse({
        roomBrandOverlayUseVO
      })
    );
  }
}
